import React, { useEffect } from 'react';
import {Modal, ModalBody, Button} from 'react-bootstrap';
import FormatMoney from '../../../Helpers/formatMoney';
import { Bounce } from 'react-activity';
import "./ModalConfirmOrder.css";

const ModalConfirm = (props) => {

  useEffect(() => {
  },[props.coinTo, props.coinExchange, props.walletExchangeTo, props.walletExchange])

  const hiddenModal = props.onHide;
  const confirmOrder = props.confirm;

  return(
    <Modal
      show={props.showModal}
      onHide={props.onHide}
      size="xs"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header style={{borderBottom: 'none', padding: '5px 15px'}} closeButton>
        <Modal.Title style={{width: '100%', textAlign: 'center'}}></Modal.Title>
      </Modal.Header>
      <ModalBody style={{padding: '0px 20px 5px'}}>
        <div style={{textAlign: 'center', marginBottom: '5px'}}>
          <span className='title-exchange'>{ props.traductions.VEX.modalCreateOrder.confirm}</span>
        </div>
        <div style={{textAlign: 'center', marginBottom: '10px'}}>
          {props?.coinExchange?.symbol &&
            <>
              <img width={36} src={require('../../../CryptoIcons/' + props?.coinExchange?.symbol + '.svg')} /> <span>{props.traductions.VEX.modalCreateOrder.From}: {props?.coinExchange?.symbol !== "usd" && props?.coinExchange?.symbol !== "vmxn" && props?.coinExchange?.symbol !== "tdc"? props?.walletExchange?.alias : props?.coinExchange?.name}</span> |
            </>
          }
          {' '}
          {props?.coinTo?.symbol &&
            <>
              <img width={36} src={require('../../../CryptoIcons/' + props?.coinTo?.symbol + '.svg')} />
              <span>{props.traductions.VEX.modalCreateOrder.To}: {props?.walletExchangeTo === "0" ? props?.coinTo?.name : props?.walletExchangeTo?.alias}</span>
            </>
          }
        </div>
        <div style={{textAlign: 'center'}}>
          <div style={{color: '#989898', fontSize: 12}}>
            {props.traductions.VEX.modalCreateOrder.price} {props && props.coinExchange && props.coinExchange.symbol && props.coinExchange.symbol === 'tdc' ? 'MXN' : props.coinExchange.symbol?.toUpperCase()}/{props && props.coinTo && props.coinTo.symbol && props.coinTo.symbol.toUpperCase()} :
          </div>
          <div style={{marginBottom: '5px'}}>
            {(props?.coinTo?.symbol === 'vmxn' ||  props?.coinTo?.symbol === 'usd' || props?.coinExchange?.symbol === 'usd' || props?.coinExchange?.symbol === 'vmxn' && props.prices !== undefined) ? FormatMoney(props.prices) : props.prices }
          </div>
          <div>
            <span style={{color: '#989898', fontSize: 12}}>
              {props.traductions.VEX.modalCreateOrder.Amount}:
            </span>
            <div style={{marginBottom: '5px'}}>
              {props.coinExchange?.symbol === 'usd' || props.coinExchange?.symbol === 'vmxn' || props.coinExchange?.symbol === 'tdc' ?    FormatMoney(props.amount) : props.amount} {props.coinExchange?.name}
            </div>
            <span style={{color: '#989898', fontSize: 12}}>
              {props.traductions.VEX.modalCreateOrder.get}:
            </span>
            <div style={{marginBottom: '5px'}}>
              {props.coinTo?.symbol === 'usd' || props.coinTo?.symbol === 'vmxn' ? FormatMoney(props.cryptoGet): props.cryptoGet} {props.coinTo?.name}
            </div>
            <span style={{color: '#989898', fontSize: 12}}>
              {props.traductions.VEX.modalCreateOrder.fee}:
            </span>
            <div>
              {props.coinExchange?.symbol === 'usd' || props.coinExchange?.symbol === 'vmxn' || props.coinExchange?.symbol === 'tdc' ?  FormatMoney(props.fee) : props.fee} {props.coinExchange?.name}
            </div>
          </div>
        </div>
      </ModalBody>

      <Modal.Footer className="modal-footer-confirm">
        <div style={{width: '100%', textAlign: 'center', marginRight: 0}}>
          <Button variant="light" className="btn-cancel-order" onClick={() => hiddenModal()}>{props.traductions.VEX.modalCreateOrder.Cancelar}</Button>
        </div>
        <div style={{width: '100%', textAlign: 'center', marginBottom: '30px'}}>
          <Button disabled={props.disabled} className="btn-confirm-order" onClick={() => confirmOrder()}>
            {
              props?.disabled ?
              <Bounce size={20} color={"#FFFFFF"} animating={props.disabled} />
              :
              props.traductions.VEX.modalCreateOrder.Confirm
            }
          </Button>
        </div>
        {
          props.coinExchange?.symbol === 'tdc' &&
          <div style={{backgroundColor:'#FFF3CD', display: 'flex', justifyContent: 'center', width: '70%'}}>
            <div>img</div>
            <div>
              <span style={{color: '#856404'}}>
                Después de proceder al pago recibirás un correo con los detalles de tu compra.
              </span>
            </div>
          </div>
        }
      </Modal.Footer>

    </Modal>
  )
}

export default ModalConfirm
